// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
exports = ___CSS_LOADER_API_IMPORT___(false);
// Module
exports.push([module.id, ".global-search-view .custom-dropdown .dropdown-list {\n  top: 45px;\n  z-index: 4;\n}", ""]);
// Exports
module.exports = exports;
